import {
    filterAutocompleteOptions,
    normalizeCompanySearch,
} from "src/v2/utils/autocomplete/filter-autocomplete-options"
import { getRootCnpj } from "src/v2/utils/cnpj-root"

export const initialValues = {
    CPFCNPJ: "",
    RazaoSocial: "",
    NomeFantasia: "",
    Setor: "",
    SubSetor: "",
    TipoCadastro: "MATRIZ",
    PeriodicidadeBalanco: "",
    MesFechamento: "12",
    EGEM: null,
    EFRF: null,
    GrupoEconomico_Nome: "",
    GrupoEconomico_RaizCNPJ: "",
    Site_RI: "",
    Atividade: "",
    Observacao: "",
    GrupoAuditoria: "",
    GrupoCustodiante: "",
    GrupoCoordenadorLider: "",
    GrupoFiduciario: "",
    GrupoIFRecebedora: "",
    GrupoSecuritizador: "",
}

export const getEconomicGroupOptions = (companies) => {
    const optionsMap = new Map()
    const sourceCompanies = Array.isArray(companies) ? companies : []

    sourceCompanies.forEach((company, index) => {
        const nomeFantasia = String(company?.NomeFantasia ?? "").trim()
        const grupoNome = String(company?.GrupoEconomico_Nome ?? "").trim()
        if (!nomeFantasia) return

        const key = nomeFantasia.toLowerCase()
        if (!optionsMap.has(key)) {
            const grupoRaiz = getRootCnpj(company?.GrupoEconomico_RaizCNPJ)

            optionsMap.set(key, {
                id: `${key}-${index}`,
                label: nomeFantasia,
                grupoEconomico: grupoNome,
                grupoEconomicoRaizCNPJ: grupoRaiz,
            })
        }
    })

    return Array.from(optionsMap.values())
        .sort((firstOption, secondOption) => firstOption.label.localeCompare(secondOption.label, "pt-BR"))
}

export const resolveEconomicGroup = (selection, options = []) => {
    if (!selection) {
        return {
            grupoEconomico: "",
            grupoEconomicoRaizCNPJ: "",
            displayLabel: "",
        }
    }

    if (typeof selection === "object") {
        return {
            grupoEconomico: selection.grupoEconomico || "",
            grupoEconomicoRaizCNPJ: selection.grupoEconomicoRaizCNPJ || "",
            displayLabel: selection.label || "",
        }
    }

    const trimmedInput = String(selection).trim()
    if (!trimmedInput) {
        return {
            grupoEconomico: "",
            grupoEconomicoRaizCNPJ: "",
            displayLabel: "",
        }
    }

    const normalizedInput = normalizeCompanySearch(trimmedInput)
    const matchingOption = options.find((opt) => {
        const normalizedLabel = normalizeCompanySearch(opt.label)

        return normalizedLabel === normalizedInput
    })

    if (matchingOption) {
        return {
            grupoEconomico: matchingOption.grupoEconomico || "",
            grupoEconomicoRaizCNPJ: matchingOption.grupoEconomicoRaizCNPJ || "",
            displayLabel: matchingOption.label || trimmedInput,
        }
    }

    return {
        grupoEconomico: trimmedInput,
        grupoEconomicoRaizCNPJ: "",
        displayLabel: trimmedInput,
    }
}

export const isEconomicGroupOptionEqualToValue = (option, value) => {
    if (!option || !value) return false
    const target = typeof value === "object" ? value.label : value
    const normalizedTarget = normalizeCompanySearch(target)
    const optionLabel = normalizeCompanySearch(option?.label)

    return optionLabel === normalizedTarget
}

export const filterEconomicGroupOptions = (options, state, activeInputValue) => {
    const rawInputValue = activeInputValue ?? (typeof state === "object" ? state?.inputValue : state) ?? ""

    return filterAutocompleteOptions(
        options,
        rawInputValue,
        {
            filterKeys: ["label"],
            normalizeFilter: normalizeCompanySearch,
            showAllOptionsOnEmpty: true,
        }
    )
}

export const toBooleanOrNull = (value) => {
    if (value === "true") return true
    if (value === "false") return false
    return null
}

export const getBooleanSelectValue = (value) => typeof value === "boolean" ? String(value) : ""

export const booleanOptions = [
    { value: "true", label: "Sim" },
    { value: "false", label: "Não" },
]

export const groupFields = [
    { name: "GrupoAuditoria", label: "Grupo Auditoria" },
    { name: "GrupoCustodiante", label: "Grupo Custodiante" },
    { name: "GrupoCoordenadorLider", label: "Grupo Coordenador Líder" },
    { name: "GrupoFiduciario", label: "Grupo Fiduciário" },
    { name: "GrupoIFRecebedora", label: "Grupo IF Recebedora" },
    { name: "GrupoSecuritizador", label: "Grupo Securitizador" },
]
